import React from "react";
import { createUseStyles } from "react-jss";
import MenuBar from "../components/MenuBar";
import Page from "../components/Page";
import { themeColors } from "../theme";
import { PageRoutes } from "../utils/routes";

const useStyles = createUseStyles({
  title: {
    fontSize: 24,
    fontWeight: "600",
    alignSelf: "flex-start",
    flexGrow: 1,
    lineHeight: 2,
    color: themeColors.blue,
    marginBottom: -8,
    "@media only screen and (max-width: 700px)": {
      marginTop: 40,
    },
  },
  aboutContainer: {
    maxWidth: 1280,
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    width: "100%",
    "@media only screen and (max-width: 700px)": {
      padding: 24,
    },
  },
  paragraph: {
    color: themeColors.blue,
    fontSize: 18,
    lineHeight: "26px",
  },
  hero: {
    textAlign: "center",
    color: themeColors.blue,
    fontSize: 22,
    fontWeight: 600,
    lineHeight: "28px",
    margin: "100px 0",
  },
});

const Tickets = () => {
  const classes = useStyles();
  return (
    <>
      <Page>
        <MenuBar selectedKey={PageRoutes.Tickets} />

        <div className={classes.aboutContainer}>
          <span className={classes.title}>Heti belépők és étkezés</span>
          <p className={classes.paragraph}>
            <span style={{ backgroundColor: themeColors.tintOrange }}>
              A Hetijegy ára 190 lej.
            </span>{" "}<br></br>
            Az ár tartalmazza a fesztiválra való belépést, a programokon való részvételt és a sátorhelyet is. <br></br>
            Hetijegyet előzetesen kizárólag online lehet vásárolni. <br></br>
            A Hetijegy ára a helyszínen 200 lej. A napijegy ára szerdára, csütörtökre és péntekre 70 lej. Kedden és szombaton a belépés ingyenes. <br></br><br></br>
            A Hetijegyen felül a Fesztivál teljes időtartamára étkezés is igényelhető. 
            <br></br>Az étkezések árai a következők: 
            <span style={{fontWeight: 800, backgroundColor: themeColors.tintGreen}}> reggeli: 27 RON, ebéd (főételt tartalmaz): 36 RON, vacsora (főételt tartalmaz): 32 RON.</span><br></br>
            A fesztivál teljes időtartamára a teljes ellátás díja <span style={{fontWeight: 800, backgroundColor: themeColors.tintOrange}}>380 RON</span>.
          </p>
          <p className={classes.paragraph}>
            <span>
              A helyszínen nem lehet étkezést igényelni, azonban a Fesztivál területén belül árusoktól különböző finomságok 
              vásárlására lesz lehetőség. A regisztráció lezárásának időpontja <span style={{ fontWeight: 800, backgroundColor: themeColors.tintGreen}}>2026. július 19., 23:59 óra;</span> ezt követően étkezés
              igénylésére már nincs lehetőség, ugyanakkor a helyszínen napi- és hetijegy vásárlása továbbra is biztosított. <br></br><br></br> {" "}
            </span>
          </p>

          <span className={classes.title}>Weekly Passes and Meals</span>
          <p className={classes.paragraph}>
            <span style={{ backgroundColor: themeColors.tintOrange }}>
              The price of a weekly pass is 190 RON.
            </span>{" "}<br></br>
            The price includes festival entry, participation in the programs, and a camping spot as well. <br></br>
            Weekly passes can only be purchased online in advance. <br></br>
            The price of a weekly pass on site is 200 RON. The daily ticket price for Wednesday, Thursday, and Friday is 70 RON. On Tuesday and Saturday, entry is free. <br></br><br></br>
            In addition to the weekly pass, meals can be requested for the entire duration of the Festival.
            <br></br>Meal prices are as follows:
            <span style={{ fontWeight: 800, backgroundColor: themeColors.tintGreen }}> breakfast: 27 RON, lunch (main course included): 36 RON, dinner (main course included): 32 RON.</span><br></br>
            The full board price for the entire Festival period is <span style={{ fontWeight: 800, backgroundColor: themeColors.tintOrange }}>380 RON</span>.
          </p>
          <p className={classes.paragraph}>
            <span>
              Meals cannot be requested on-site; however, various food options will be available for purchase from vendors within the Festival area. The registration deadline is <span style={{ fontWeight: 800, backgroundColor: themeColors.tintGreen }}>July 19, 2026, at 23:59;</span> after this, it will no longer be possible to request meals. However, daily and weekly passes will still be available for purchase on-site. <br></br><br></br> {" "}
            </span>
          </p>
          
        </div>
      </Page>
    </>
  );
};

export default Tickets;
